<div #top class="container dark-green" *ngIf="!initialLoading; else skeleton">
  <app-extension-details [isInstalled]="isInstalled" [version]="version" [planId]="planId"
    [isChromeBrowser]="isChromeBrowser"></app-extension-details>

  <app-flygrammar-settings #grammarCard [initialEnabled]="flyGrammarEnabled" [initialLanguage]="flyGrammarLanguage"
    [languages]="flyGrammarLanguagesAvailable"
    [adminOverride]="flyGrammarOverrideUser" [canDisableFlyGrammar]="canDisableFlyGrammar"
    (dirtyChange)="onDirtyChange('FlyGrammar', $event, grammarCard)"></app-flygrammar-settings>

  <app-flyrewrite-settings #rewriteCard [initialEnabled]="flyRewriteEnabled"
    [adminOverride]="flyRewriteOverrideUser"
    (dirtyChange)="onDirtyChange('AI Paragraph Rewriter', $event, rewriteCard)"></app-flyrewrite-settings>

  <app-sentence-rewrite-settings #sentenceRewriteCard *ngIf="sentenceRewriterAccessGranted"
    [initialEnabled]="sentenceRewriteEnabled"
    [adminOverride]="sentenceRewriteOverrideUser"
    (dirtyChange)="onDirtyChange('FlyMSG Sentence Rewriter', $event, sentenceRewriteCard)"></app-sentence-rewrite-settings>

  <app-typing-style-settings #typingCard [initialTypingStyle]="typingStyle" [initialTypingSpeed]="typingSpeed"
    [adminOverride]="typingStyleOverrideUser"
    (dirtyChange)="onDirtyChange('Typing Style', $event, typingCard)"></app-typing-style-settings>

  <app-flycut-timeout-settings #timeoutCard [initialTimeout]="timeout"
    (dirtyChange)="onDirtyChange('FlyCut Timeout', $event, timeoutCard)"></app-flycut-timeout-settings>

  <app-disabled-sites-settings #disabledSitesCard [shortcutsBlockedDomains]="blockedDomains"
    [grammarBlockedDomains]="flyGrammarBlockedDomains" [rewriteBlockedDomains]="flyRewriteBlockedDomains"
    [pluginBlockedDomains]="pluginBlockedDomains" [sentenceRewriteBlockedDomains]="sentenceRewriteBlockedDomains"
    [grammarAdminOverride]="flyGrammarOverrideUser"
    [rewriteAdminOverride]="flyRewriteOverrideUser" [sentenceRewriteAdminOverride]="sentenceRewriteOverrideUser"
    [grammarGloballyEnabled]="flyGrammarEnabled"
    [rewriteGloballyEnabled]="flyRewriteEnabled" [sentenceRewriteGloballyEnabled]="sentenceRewriteEnabled"
    [canDisableFlyGrammar]="canDisableFlyGrammar"
    [sentenceRewriterAccessGranted]="sentenceRewriterAccessGranted"
    (dirtyChange)="onDirtyChange('Disabled Sites', $event, disabledSitesCard)"></app-disabled-sites-settings>

  <!-- CSV Split Separator is not available for now
  <app-csv-separator-settings
    #csvSeparatorCard
    [initialSeparator]="csvSplitSeparator"
    (dirtyChange)="onDirtyChange('CSV Split Separator', $event, csvSeparatorCard)"
  ></app-csv-separator-settings> 
  -->

  <div class="scroll-top" style="display:flex; justify-content:flex-end; align-items:center">
    <button type="button" vng-button variant="ghost" class="no-color scroll-button"
      (click)="scrollService.scrollTo(top)" id="scroll-up">
      <svg-icon-sprite width="14px" height="14px" src="icon-ico-scroll-up"> </svg-icon-sprite>
    </button>
  </div>
</div>

<ng-template #skeleton>
  <div class="container dark-green">
    <div class="settings-box-shadow" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]">
      <ngx-skeleton-loader count="1"
        [theme]="{ height: '24px', width: '200px', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1"
        [theme]="{ height: '14px', width: '100%', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1"
        [theme]="{ height: '48px', width: '100%', 'border-radius': '16px' }"></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>